var exports = {
  "Q": "xaf9ae18d--340257--content",
  "x": "xaf9ae18d--340257--button",
};

module.exports = exports;
